/** แบนโครงสร้าง planned/standard/actual/variance ของต้นทุนใบสั่งผลิต (D-190) ให้ตารางอ่านได้ */

import type { RecordRow } from '../../lib/backend/records';

export function costElement(row: RecordRow, group: string, key: string): unknown {
  const value = row[group];
  return typeof value === 'object' && value !== null ? (value as RecordRow)[key] : undefined;
}

export function flattenOrderCost(row: RecordRow): RecordRow {
  const missing = Array.isArray(row.missing) ? (row.missing as unknown[]).join(', ') : '';
  return {
    ...row,
    standard_total: costElement(row, 'standard', 'total'),
    actual_total: costElement(row, 'actual', 'total'),
    variance_total: costElement(row, 'variance', 'total'),
    missing_text: missing,
  };
}
